import React from 'react'
import { SectionContainer } from '@/components/SectionContainer'
import { Glossary, GlossaryLevel } from '@/types/glossary'
import Breadcrumb from '@/components/Breadcrumb'
import ArticleTags, { BadgeType } from '@/components/ArticleTags'
import ArticleContent from '@/components/ArticleContent'
import { Heading, Box, Divider, Flex, Icon, VStack } from '@chakra-ui/react'
import RelatedWordsSection from '@/components/RelatedWordsSection'
import { useTranslation } from 'react-i18next'
import { ShareContainer } from '@/components/ShareContainer'

const GlossaryDetails = ({
  definition,
  relatedWords,
}: {
  definition: Glossary
  relatedWords: Glossary[]
}) => {
  const { t } = useTranslation()
  const tags =
    definition?.tags
      ?.filter((x) => x !== 'Easy' && x !== 'Hard')
      .map((tag) => ({
        text: tag,
        type: 'tag' as BadgeType,
      })) || []
  const level = definition?.tags?.filter(
    (tag) => tag === 'Easy' || tag === 'Hard'
  )
  if (level.length > 0) {
    tags.unshift({ text: level[0], type: 'level' })
  }
  if (!definition) return <></>

  return (
    <SectionContainer
      containerStyle={{
        paddingTop: [20, null, null, 24],
        paddingBottom: [40, null, null, 60],
      }}
    >
      <Breadcrumb currentItem={definition.title} />
      <Box px={[0, null, null, 69]} mt={[17, null, 48, null]}>
        <Flex justifyContent={'space-between'} alignItems={'center'}>
          <ArticleTags tags={[...tags]} />
          <Box display={['none', null, 'inline-flex', null]}>
            <ShareContainer slug={definition.slug} />
          </Box>
        </Flex>
        <article>
          <Heading
            as="h1"
            mt={[19, null, 16, null]}
            fontSize={['24px', null, '48px', null]}
            lineHeight={['125%', null, '115%', null]}
            dangerouslySetInnerHTML={{
              __html: definition.acf.full_name
                ? `${definition.title} (${definition.acf.full_name})`
                : definition.title,
            }}
          />
          <Divider
            mt="24px"
            mb="40px"
            background="#0D1426"
            h="1.5px"
            opacity={1}
          />
          <ArticleContent
            content={definition.content}
            key_takeaway={definition.acf.key_takeaway}
          />
        </article>
      </Box>
      <RelatedWordsSection relatedWords={relatedWords.slice(0, 10)} />
    </SectionContainer>
  )
}

export default GlossaryDetails
